var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user_name)?_c('span',{staticClass:"request-by hover",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick()}}},[_c('i',[_vm._v(" ["+_vm._s(_vm.user_name)+"]")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }